const Icon = () => {
	return (
		<div className="flex gap-1 hover:cursor-grab ">
			<div className="flex flex-col gap-1">
				<div className="w-4 h-4 bg-transparent border-2 border-solid rounded-full "></div>
				</div>
		</div>
	);
};

export default Icon;
